import React from "react"
import {
  zoneLibre,
  zoneLibreTitle,
  zoneLibreIndex,
  zoneLibreIndexOne,
  zoneLibreIndexTwo,
  zoneLibreIndexThree,
  zoneLibreIndexNePasManquer,
  zoneLibreLink,
  editButton,
} from "./contenu-libre.module.scss"
import {
  masonryGrid,
  masonryGridColumn,
  galerieContainer,
  galerieItemContainer,
  galerieItemHeader,
  galerieItemLink,
  galerieItemDescription,
} from "gatsby-theme-blank/src/components/Home/GalerieImages/galerie-images.module.scss"
import Teleformulaire from "gatsby-theme-blank/src/components/Teleformulaire/teleformulaire"
import EditButton from "gatsby-theme-blank/src/components/EditButton/edit-button"
import ContentTransformer from "gatsby-theme-blank/src/components/Transformers/content-transformer"
import PropTypes from "prop-types"
import { useBuildData } from "gatsby-theme-blank/src/hooks/use-build-data"
import { Title, ZoneLibre, SeeNextLink } from "./contenu-libre-styled"
import { useContenuLibre } from "gatsby-theme-blank/src/components/ContenuLibre/contenu-libre-query"
import FinalGalerieComponent from "gatsby-theme-blank/src/components/Home/GalerieImages/final-galerie-component"
import TransitionFade from "gatsby-theme-blank/src/components/transition-fade"
import { summaryLength } from "gatsby-theme-blank/src/constants/index"
import SummaryTransformer from "gatsby-theme-blank/src/components/Transformers/summary-transformer"
import { GalerieItemContainer } from "gatsby-theme-blank/src/components/Home/GalerieImages/galerie-images-styled"
import { LightBoxImage } from "gatsby-theme-blank/src/components/LightBoxImage/light-box-image"

//-----------------------Parent component---------------------------//

const ContenuLibre = ({ zoneTaxoLibre, isIndex, index, bannerItem }) => {
  const buildColors = useBuildData().theme_settings.palette
  const data = useContenuLibre()
  const contenusLibre = data.allNodeContenuLibre.edges
  const teleformulaires = data.allNodeTeleformulaires.edges
  const galerie = data.allNodeGalerieDImages.edges
  const resultTeleform = teleformulaires
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  let resultContenuLibre

  if (zoneTaxoLibre === "zone_bandeau_accueil") {
    resultContenuLibre = bannerItem
  } else {
    resultContenuLibre = contenusLibre
      .filter(
        ({ node }) =>
          node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
      )
      .shift()
  }

  const resultGalerie = galerie
    .filter(
      ({ node }) =>
        node.relationships?.field_taxonomie_zone_libre?.name === zoneTaxoLibre
    )
    .shift()
  const bothNodes = [resultTeleform, resultContenuLibre, resultGalerie]
  const result = bothNodes
    .sort((firstDate, lastDate) => {
      if (firstDate.node.created > lastDate.node.created) return -1
      if (firstDate.node.created < lastDate.node.created) return 1
      return 0
    })
    .shift()
  if (!result) return null
  let zoneLibreColor = "white"
  let zoneLibreColorMobile = "white"
  let zoneLibreClassName = zoneLibre
  if (isIndex) {
    zoneLibreClassName = zoneLibreIndex
    zoneLibreColor = buildColors.a_color_gradients.a_light

    if (zoneTaxoLibre === "zone_accueil_1") {
      zoneLibreClassName = `${zoneLibreIndexOne} ${zoneLibreIndex}`
      zoneLibreColorMobile = buildColors.a_color_gradients.a_medium
    }
    if (zoneTaxoLibre === "zone_accueil_2") {
      zoneLibreClassName = `${zoneLibreIndexTwo} ${zoneLibreIndex}`
      zoneLibreColor = buildColors.a_color_gradients.a_medium + 33
      zoneLibreColorMobile = buildColors.a_color_gradients.a_medium + 33
    }
    if (zoneTaxoLibre === "zone_accueil_3") {
      zoneLibreClassName = `${zoneLibreIndexThree} ${zoneLibreIndex}`
    }
    if (zoneTaxoLibre === "zone_accueil_4") {
      zoneLibreClassName = `${zoneLibreIndexNePasManquer} ${zoneLibreIndex}`
    }
    if (zoneTaxoLibre === "zone_bandeau_accueil") {
      zoneLibreClassName = zoneLibreIndex
    }
  }
  let contentZoneLibre = (
    <>
      <Teleformulaire zoneLibre={true} teleform={result.node} />
      <TransitionFade className={zoneLibreLink} link={result.node.path.alias}>
        <SeeNextLink>
          Voir
          <span aria-hidden={true}>&rarr;</span>
        </SeeNextLink>
      </TransitionFade>
    </>
  )
  if (result.node.internal.type === "node__contenu_libre") {
    contentZoneLibre = (
      <>
        <Title className={zoneLibreTitle}>{result.node.title}</Title>
        <ContentTransformer content={result.node.body?.processed} />
        <TransitionFade
          className={zoneLibreLink}
          link={result.node.path.alias}
          tabIndex={"0"}
        >
          <SeeNextLink>
            Voir
            <span aria-hidden={true}> &rarr;</span>
          </SeeNextLink>
        </TransitionFade>
      </>
    )
  }
  if (result.node.internal.type === "node__galerie_d_images") {
    contentZoneLibre = (
      <article>
        <Title className={zoneLibreTitle}>{result.node.title}</Title>
        <GalerieItemContainer className={galerieContainer}>
          <FinalGalerieComponent zoneLibre={true} data={result.node}>
            {({ images }) => (
              <div className={galerieItemContainer}>
                <div className={galerieItemHeader}>
                  <div className={galerieItemDescription}>
                    {result.node.body && (
                      <p
                        style={{ marginBottom: "0" }}
                        dangerouslySetInnerHTML={{
                          __html: SummaryTransformer(
                            result.node.body,
                            summaryLength
                          ),
                        }}
                      />
                    )}
                  </div>
                  <div className={galerieItemLink}>
                    <TransitionFade
                      className="btn"
                      link={result.node.path.alias}
                    >
                      Voir l&apos;intégralité de la galerie
                    </TransitionFade>
                  </div>
                </div>
                <LightBoxImage
                  type={"masonry"}
                  node={{
                    images: images,
                    className: masonryGrid,
                    columnClassName: masonryGridColumn,
                  }}
                />
              </div>
            )}
          </FinalGalerieComponent>
        </GalerieItemContainer>
      </article>
    )
  }
  return (
    <>
      <ZoneLibre
        bgColorMobile={zoneLibreColorMobile}
        bgColor={zoneLibreColor}
        isIndex={isIndex}
        className={zoneLibreClassName}
      >
        {zoneTaxoLibre === "zone_bandeau_accueil" ? null : (
          <EditButton
            link={"/node/" + result.node.drupal_internal__nid + "/edit"}
            addedClass={editButton}
          />
        )}

        {contentZoneLibre}
      </ZoneLibre>
    </>
  )
}

//-----------------------Parent component---------------------------//

//-----------------------Prop-Types---------------------------//

ContenuLibre.propTypes = {
  zoneTaxoLibre: PropTypes.string.isRequired,
  isIndex: PropTypes.bool,
  index: PropTypes.number,
  bannerItem: PropTypes.object,
}
//-----------------------Prop-Types---------------------------//

export default ContenuLibre
